import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const DEFAULT_INCLUDE_STRING = [
  'brand.accounts.service',
  'filters_stories',
  'filters_services',
  'filters_labels',
  'filters_accounts',
  'filters_label_sets',
].join(',')

const fetchBrandSettings = (params) =>
  HttpClient().get('/brand_settings/v2', {
    params: {
      'filter[brand_id]': params.brandId,
      filter_namespace: params.filter_namespace,
      include: DEFAULT_INCLUDE_STRING,
    },
  })

const getBrandSettingsV2 = (params) => (dispatch) =>
  fetchBrandSettings(params)
    .then((response) => dispatch(loadJsonApiEntities(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getBrandSettingsV2
